import { Button, makeStyles } from '@material-ui/core'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import AIIcon from 'resources/AIIcon'
import AIInfoIcon from 'resources/AIInfoIcon'
import React from 'react'
import {
    SPEC_INT_GRADIENT,
    SPEC_INT_GRADIENT_HOVER,
    SPEC_INT_PANEL_BACKGROUND_COLOR,
} from './specIntelligenceConstants'

const useStyles = makeStyles(() => ({
    bar: {
        display: 'flex',
        alignItems: 'center',
        gap: pxToRem(8),
        padding: `${pxToRem(8)} ${pxToRem(12)}`,
        borderBottom: '1px solid #E0E0E0',
        backgroundColor: SPEC_INT_PANEL_BACKGROUND_COLOR,
        flexShrink: 0,
    },
    rerunButton: {
        flex: 1,
        background: SPEC_INT_GRADIENT,
        color: '#FFFFFF',
        fontSize: pxToRem(13),
        fontWeight: 500,
        textTransform: 'none' as const,
        '&:hover': {
            background: SPEC_INT_GRADIENT_HOVER,
        },
    },
    rerunIcon: {
        width: pxToRem(16),
        height: pxToRem(16),
    },
    disclaimerButton: {
        flexShrink: 0,
        fontSize: pxToRem(12),
        fontWeight: 400,
        color: '#185E8E',
        whiteSpace: 'nowrap' as const,
    },
    disclaimerButtonIcon: {
        width: pxToRem(16),
        height: pxToRem(16),
    },
}))

/** Props for {@link SpecIntelligenceActionBar}. */
export interface SpecIntelligenceActionBarProps {
    /** When provided, a Re-run Analysis button is shown alongside Disclaimer. */
    onRerun?: () => void
    /** Called when the user clicks the Disclaimer button. */
    onInfoOpen: () => void
}

/**
 * Action row below the drawer header — Re-run Analysis (when applicable) and
 * Disclaimer. In the results view this renders below the stat tiles; in other
 * views it renders directly below the header.
 */
const SpecIntelligenceActionBar = ({ onRerun, onInfoOpen }: SpecIntelligenceActionBarProps) => {
    const classes = useStyles()
    return (
        <div className={classes.bar}>
            {onRerun && (
                <Button
                    size="small"
                    onClick={onRerun}
                    className={classes.rerunButton}
                    aria-label="Re-run analysis"
                    startIcon={<AIIcon className={classes.rerunIcon} aria-hidden="true" />}
                    disableRipple
                    disableFocusRipple
                    data-testid="reRunAnalysisButton"
                >
                    Re-run Analysis
                </Button>
            )}
            <Button
                id="showSpecIntelligenceDisclaimerButton"
                data-testid="showSpecIntelligenceDisclaimerButton"
                size="small"
                onClick={onInfoOpen}
                aria-label="Insights info"
                className={classes.disclaimerButton}
                startIcon={<AIInfoIcon className={classes.disclaimerButtonIcon} aria-hidden="true" />}
                disableRipple
                disableFocusRipple
            >
                Disclaimer
            </Button>
        </div>
    )
}

export default SpecIntelligenceActionBar
